import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/blog-evenements/page.tsx");
